import { getDate } from "./date";

export function compareDates(a, b) {
  a = getDate(a);
  b = getDate(b);
  return a.isSame(b) ? 0 : a.isAfter(b) ? 1 : -1;
}

export function compareModifiedStates(a, b) {
  a = a.props.line.is_modified;
  b = b.props.line.is_modified;
  return a === b ? 0 : a > b ? 1 : -1;
}
